<template>
    <div>
        <div class="thread-no-notification" v-if="notifications.data && notifications.data.length === 0">
            <figure>
                <svg-icon icon="bell-big"></svg-icon>
            </figure>

            <strong>{{ __("No new notifications") }}</strong>
        </div>

        <div class="thread-list-aside" v-else>
            <a :href="`/forum/diskuze/${notification.data.thread_id}${notificationCommentUrl(notification)}`" v-for="notification in notifications.data" class="thread-wrapper" :class="notificationClass(notification)">
                <header>
                    <strong class="title">{{ notification.data.title }}</strong>
                    <span class="thread-label">{{ __(notification.data.message) }}</span>
                </header>

                <p class="parse-mention">{{ notification.data.body }}</p>
            </a>
        </div>

        <ul class="pagination" v-if="notifications.meta && notifications.meta.last_page !== 1">
            <li :class="{'disabled': !notifications.links.prev }">
                <a v-if="notifications.links.prev" href="#" @click.prevent="fetch(notifications.links.prev)" rel="prev">
                    <span class="material-icons-round">chevron_left</span>
                </a>
                <span v-else>
                    <span class="material-icons-round">chevron_left</span>
                </span>
            </li>
            <li :class="{'active': notifications.meta.current_page === 1}">
                <a href="#" @click.prevent="fetch(getUrl(1))">
                    <span>1</span>
                </a>
            </li>
            <li v-if="notifications.meta.current_page > 3" class="disabled">
                <span>...</span>
            </li>
            <li v-for="(item, index) in rangeLinks" v-if="index + 1 >= (notifications.meta.current_page - 2) && index + 1 <= (notifications.meta.current_page)" :class="{'disabled': !item.url, 'active': item.active}">
                <a href="#" @click.prevent="fetch(item.url)">
                    <span>{{ item.label }}</span>
                </a>
            </li>
            <li v-if="notifications.meta.current_page < notifications.meta.last_page - 3" class="disabled">
                <span>...</span>
            </li>
            <li :class="{'active': notifications.meta.current_page === notifications.meta.last_page}">
                <a href="#" @click.prevent="fetch(getUrl(notifications.meta.last_page))">
                    <span>{{ notifications.meta.last_page }}</span>
                </a>
            </li>
            <li :class="{'disabled': !notifications.links.next }">
                <a v-if="notifications.links.next" href="#" @click.prevent="fetch(notifications.links.next)" rel="next">
                    <span class="material-icons-round">chevron_right</span>
                </a>
                <span v-else>
                    <span class="material-icons-round">chevron_right</span>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import Forum from '@/core/Forum'

export default {
    data() {
        return {
            notifications: {
                data: null
            }
        }
    },
    computed: {
        rangeLinks() {
            return this.notifications.meta.links.slice(2, this.notifications.meta.last_page)
        }
    },
    mounted() {
        this.fetch()
    },
    methods: {
        fetch(url) {
            var fetchUrl = "/forum/coach-notifications" 

            if(url) {
                fetchUrl = url
            }

            axios.get(fetchUrl)
                .then((r) => {
                    this.notifications = r.data

                    setTimeout(() => {
                        Forum.parseCommentMentions()
                    }, 100)
                })
        },
        notificationClass(notification) {
            if(notification.data.type === "new_thread") {
                return notification.read_at ? 'read' : 'new'
            } else {
                return notification.read_at ? 'read' : 'marked'
            }
        },
        notificationCommentUrl(notification) {
            if(notification.data.comment_id) {
                return `?comment=${notification.data.comment_id}`
            } else {
                return ''
            }
        },
        getUrl(index) {
            return this.notifications.meta.links[index].url
        }
    }
}
</script>
